/**
 * @namespace Datawrapper
 * @aka SWR.Datawrapper
 */
SWR.Datawrapper = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'datawrapper';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: 'iframe[data-embed-type="datawrapper"]'
  };

  var Default = {};

  var DefaultType = {};

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Datawrapper = function () {

    function Datawrapper(element, config) {
      COMMON.Utils._classCallCheck(this, Datawrapper);

      var self = this;

      // protected
      self.element = element;
      self.config = self._getConfig(config);
      self.$element = $(self.element);

      var url = self.$element.attr('src');
      self._id = 'datawrapper-chart-' + COMMON.Utils.parseUrl(url).segments[0];
      self._key = '.' + self._id;

      self.$element.attr({
        'id': self._id,
        'scrolling': 'no',
        'frameborder': 0
      }).css('width', '100%');

      self.registerEventHandlers();
    }

    Datawrapper.prototype.registerEventHandlers = function registerEventHandlers() {
      var self = this;

      $(document).one('pjax:end' + EVENT_KEY, function (event) {
        self.$element.off(EVENT_KEY);
        $(window).off(self._key + EVENT_KEY);
        $(document).off(self._key + EVENT_KEY);
        self._key = null;
        self._id = null;

        self.$element = null;
        self.element = null;
      });

      $(window).on('message' + self._key + EVENT_KEY, function (event) {
        var message = event.originalEvent.data;

        if (!message.hasOwnProperty('datawrapper-height')) {
          return;
        }

        for (var key in message['datawrapper-height']) {
          if ('datawrapper-chart-' + key !== self._id) {
            return;
          }

          self.$element.css('height', message['datawrapper-height'][key] + 'px');
        }
      });
    };

    // public
    Datawrapper.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);
      $(window).off(this._key + EVENT_KEY);
      $(document).off(this._key + EVENT_KEY);
      this._key = null;
      this._id = null;

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // private
    Datawrapper.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);

      COMMON.Utils.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    // static
    Datawrapper._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = $.extend({}, Default, $(this).data());

        if (!data) {
          data = new Datawrapper(this, _config);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Datawrapper;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Datawrapper._jQueryInterface.call($element, $element.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Datawrapper._jQueryInterface.call($element);
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Datawrapper._jQueryInterface;
  $.fn[NAME].Constructor = Datawrapper;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Datawrapper._jQueryInterface;
  };

  return Datawrapper;

})(window.jQuery);
